import { Injectable } from "@angular/core";
import{ Http, Headers } from "@angular/http";
import { map, timeout} from 'rxjs/operators';
import { GLOBAL } from './global';

@Injectable()
export class DocumentoService {
    public url;

    constructor(private _http: Http){
        this.url = GLOBAL.url;
    }

    getDocumento(){
       return this._http.get("assets/json/pasos.json")
        .pipe(map(res => res.json()));
    }
    getUploaders(){
        return this._http.get("assets/json/documentos.json")
         .pipe(map(res => res.json()));
     }
    uploadFile(file){
        let headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url+'save/archivos', file, {headers: headers})
        .pipe(map(res=> res.json()));
    }

    uploadF(files, user){
        let headers = new Headers({
            'Content-Type': 'application/json',
        });

        var params =  {
            files: files,
            user : user
        }

        return this._http.post(this.url+'upload/ftp', params, {headers:headers})
        
    }

    uploadFiles(files, formType = ''){

        const formData  = new FormData();
        formData.append('formType', formType)

        files.map((file) => {
            if (!(file == null || file== undefined)) {
                let doExt = file.doc.name.split(".")
                doExt = file.name +'-'+ new Date().getTime() + '.' + doExt[ doExt.length -1 ]
                let fil: File
                fil = file.doc
                formData.append('uploads[]', fil , doExt);
            }
        })
            return this._http.post(this.url + 'upload/dbx', formData)
            .pipe(map((res) => res.json()))
    }


    uploadFilesObs(files, formType = ''){

        const formData  = new FormData();
        formData.append('formType', formType)

        files.map((file) => {
            if (!(file == null || file== undefined)) {
                let doExt = file.doc.name.split(".")
                doExt = file.name +'-'+ new Date().getTime() + '.' + doExt[ doExt.length -1 ]
                let fil: File
                fil = file.doc
                formData.append('uploads[]', fil , doExt);
            }
        })
            return this._http.post(this.url + 'upload/dbxpobs', formData)
            .pipe(map((res) => res.json()))
    }

}
